export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./VuesticChart.vue?vue&type=template&id=5ae34986"


//////////////////
// WEBPACK FOOTER
// ./src/vuestic-theme/vuestic-components/vuestic-chart/VuesticChart.vue?vue&type=template&id=5ae34986
// module id = c1XL
// module chunks = 41